//blackout surcharge - both use D11

export function calculateD11(totalWidths, finishedLength, interliningOrBlackout, COM) {
      console.log('calculateD11() start');
      console.log('- ', totalWidths, interliningOrBlackout, COM);

      const lengthRanges = [
            { min: 0, max: 16, prices: [17, 34, 51, 68, 85, 102, 119, 136, 153, 170] },
            { min: 17, max: 36, prices: [29, 58, 87, 116, 145, 174, 203, 232, 261, 290] },
            { min: 37, max: 48, prices: [37, 74, 111, 148, 185, 222, 259, 296, 333, 370] },
            { min: 49, max: 60, prices: [45, 90, 135, 180, 225, 270, 315, 360, 405, 450] },
            { min: 61, max: 72, prices: [52, 104, 156, 208, 260, 312, 364, 416, 468, 520] },
            { min: 73, max: 84, prices: [60, 120, 180, 240, 300, 360, 420, 480, 540, 600] },
            { min: 85, max: 96, prices: [68, 136, 204, 272, 340, 408, 476, 544, 612, 680] },
            { min: 97, max: 108, prices: [75, 150, 225, 300, 375, 450, 525, 600, 675, 750] },
            { min: 109, max: 120, prices: [83, 166, 249, 332, 415, 498, 581, 664, 747, 830] },
      ];

      const extraLengthStep = 12;
      const extraLengthPrice = [14, 28, 42, 56, 70, 84, 98, 112, 126, 140];

      if (totalWidths < 1 || totalWidths > 10) {
            console.log('- invalid total width. must be 1-10');
            return 0;
      }

      const widthIndex = totalWidths - 1;

      if (interliningOrBlackout ==  "RM Designer Deluxe Cotton Sateen" || interliningOrBlackout == "RM Designer Deluxe Cotton FR Sateen" || interliningOrBlackout == "RM Designer Recycled Royal Satin" || interliningOrBlackout == "RM Designer Napped Sateen" || interliningOrBlackout == 'RM Designer 3 Pass Non-FR Outblack' || interliningOrBlackout == 'RM Designer Lite Tech Blackout' || interliningOrBlackout == 'RM Designer Flametrol 3 Pass FR Blackout') {
            // Check for base ranges
            for (let range of lengthRanges) {
                  if (finishedLength >= range.min && finishedLength <= range.max) {
                        return range.prices[widthIndex];
                  }
            }

            // Calculate extra charges if finishedLength > 120
            if (finishedLength > 120) {
                  const base = lengthRanges[lengthRanges.length - 1];
                  const extraLength = finishedLength - 120;
                  const extraUnits = Math.ceil(extraLength / extraLengthStep);
                  const surcharge = base.prices[widthIndex] + extraUnits * extraLengthPrice[widthIndex];
                  return surcharge;
            }
            // if (COM == true) {
            //       switch (totalWidths) {
            //             case 1:
            //                   return 173;
            //             case 2:
            //                   return 308;
            //             case 3:
            //                   return 448;
            //             case 4:
            //                   return 615;
            //             case 5:
            //                   return 777;
            //             case 6:
            //                   return 939;
            //             case 7:
            //                   return 1101;
            //             case 8:
            //                   return 1247;
            //             case 9:
            //                   return 1408;
            //             case 10:
            //                   return 1554;
            //             default:
            //                   console.log(
            //                         '- invalid totalWidths. must be 1-10'
            //                   );
            //                   return 0;
            //       }
            // } else {
            // }
      } else {
            return 0;
      }
}

